import {Injectable} from '@angular/core';

import {StoreConfig} from '@datorama/akita';
import {GridStore} from '@q9elements/ui-kit/components';

import {ActivatedRoute} from '@angular/router';
import {CodeSearchEntity} from './code-search-entity';

@Injectable()
@StoreConfig({name: 'code-search', idKey: '_id', resettable: true})
export class CodeSearchStore extends GridStore<CodeSearchEntity> {
  constructor(private route: ActivatedRoute) {
    super({
      ...route.snapshot.queryParams
    });
  }
}
